export default "__VITE_ASSET__BFt2Tk1f__"